import { defineMessages } from "react-intl";

export default defineMessages({
  btnSendCode: {
    id: "Customer.CustomerEditForm.btnSendCode",
    defaultMessage: "Send confirmation code",
  },
});
